import React, { useEffect } from 'react';
import { useEntryPoint } from '@atlassian/jira-entry-point';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container';
import { RatingFeedbackCollector } from './entrypoint';

const runtimeProps = {};
const entryPointParams = {};
const RatingFeedbackCollectorAsync = () => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		RatingFeedbackCollector,
		entryPointParams,
	);

	useEffect(() => {
		entryPointActions.load();
		return () => {
			entryPointActions.unload();
		};
	}, [entryPointActions]);

	return (
		<JiraEntryPointContainer
			id="ploverview-survey-feedback"
			packageName="jiraPortfolio3Portfolio"
			entryPointReferenceSubject={entryPointReferenceSubject}
			teamName="Chronos"
			runtimeProps={runtimeProps}
		/>
	);
};

export default RatingFeedbackCollectorAsync;
